import { GetterTree } from 'vuex'
import { RootState } from '@/store/types/storeGlobalTypes'
import {
  AmendItemType,
  BankdataIdEnum,
  IBankdata,
  IFacturaEState,
  IProfessional,
  paymentTypeWithBankdata,
  TaxNetworkEnum
} from '@/store/modules/facturaE/facturaETypes'
import { arrayHasItems } from '@/helpers/array'

export const getters: GetterTree<IFacturaEState, RootState> = {
  getActiveProfessionalTaxNetwork(state: IFacturaEState): TaxNetworkEnum | null {
    const professional: IProfessional | null = state.selectedProfessional
    if (!professional || !('taxNetwork' in professional) || !('facturaEActive' in professional)) {
      return null
    }
    if (!professional.facturaEActive || !professional.taxNetwork) {
      return null
    }

    return professional.taxNetwork
  },
  getAmendReason(state: IFacturaEState): AmendItemType[] {
    return state.amendReason
  },
  getAmendCodeTax(state: IFacturaEState): AmendItemType[] {
    return state.amendCodeTax
  },
  getBankdata(state: IFacturaEState): IBankdata[] {
    return state.bankdata
  },
  isPaymentTypeWithBankdata(state: IFacturaEState): boolean {
    return paymentTypeWithBankdata[String(state.paymentType) as BankdataIdEnum] !== undefined
  },
  isDirectDebitWithoutBankdata(state: IFacturaEState): boolean {
    return BankdataIdEnum.DIRECT_DEBIT_ID === String(state.paymentType)
      && !arrayHasItems(state.bankdata)
  },
}
